import Breadcrumb from 'shopper/components/Breadcrumb/V1/Breadcrumb';

import BreadcrumbItem from 'components/Breadcrumb/Item';

import placeholder from 'lib/placeholder';

import LINKS from 'constants/links';

const StoresHeading = (props) => (
  <Breadcrumb {...props}>
    <BreadcrumbItem href={LINKS.HOME}>
      {placeholder('breadcrumbs.app')}
    </BreadcrumbItem>
    <BreadcrumbItem>{placeholder('breadcrumbs.stores')}</BreadcrumbItem>
  </Breadcrumb>
);

export default StoresHeading;
